import L, { Map } from "leaflet";
import { CustomMarker } from "@/components/map/utils/customs";

export function locateMe(map: Map) {
  const successCallback = (position: GeolocationPosition) => {
    var coordinates = new L.LatLng(
      position?.coords?.latitude,
      position?.coords?.longitude
    );
    map.flyTo(coordinates, 18);
    L.marker(coordinates, { icon: CustomMarker }).addTo(map);
  };

  const errorCallback = (error: GeolocationPositionError) => {
    alert(error.message);
  };

  const options = {
    enableHighAccuracy: true,
    timeout: 10000,
  };

  navigator.geolocation.getCurrentPosition(
    successCallback,
    errorCallback,
    options
  );
}
